var map = {
	"./auth/router.js": "c613",
	"./autoship/router.js": "dd7a",
	"./bonus/router.js": "a7dd",
	"./campaigns/router.js": "e539",
	"./dashboard/router.js": "79e3",
	"./esac-points/router.js": "ce44",
	"./evoucher/router.js": "45e9",
	"./ewallet/router.js": "7f30",
	"./global/router.js": "11ca",
	"./inventory/router.js": "bf96",
	"./itoken/router.js": "a8e7",
	"./members/router.js": "8443",
	"./procurement/router.js": "dc14",
	"./products/router.js": "f155",
	"./receipt/router.js": "3fbf",
	"./reports/router.js": "b9c9",
	"./sales/router.js": "00d4",
	"./settings/router.js": "4ece",
	"./smart-library/router.js": "56a3",
	"./stockist/router.js": "8e3c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "87c1";